<template>
    <header>
        <a href="javascript:;" v-for="(item,i) in navs" class="lnav" @click="go(i)" :key="i">{{item.name}}</a>
        <div class="right">
            <div v-if="userInfo.username">
                <!-- <a href="javascript:;" class="ftBtn" @click="open">发帖</a> -->
                <img class="avatar" :src="userInfo.avatar" alt="">
                <a href="#/pcenter" class="username">{{userInfo.username}}</a>
            </div>
            <a v-else href="#/arealogin" class="ftBtn">登录</a>
        </div>
        <Applets :isShow="isShow" @closeFn="closeFn"></Applets>
    </header>
</template>
<script>
import { storageData } from "@/assets/js/storage";
import Applets from '../common/applets'
export default {
    data() {
        return {
            navs:[
                {name:'推荐'},
                // {name:'最新'},
                {name:'二手'},
                // {name:'房产'},
                // {name:'交友'},
                {name:'活动'}
            ],
            userInfo:{
                username:'',
                avatar:''
            },
            isShow:false,
            streetId:''
        }
    },
    computed:{

    },
    components:{
      Applets
    },
    components:{
      Applets
    },
    mounted() {
        let hlink = window.location.href
        if(hlink.indexOf('bjdongba.cn')>-1) {
            this.streetId = '110105039000'
        }
        // 已登录
        if(storageData.getUserInfo()) {
          this.userInfo = storageData.getUserInfo()
        }else{
            this.userInfo = {
                username:'',
                avatar:''
            }
        }
    },
    methods:{
        open(){
          this.isShow = true
        },
        closeFn(msg) {
            this.isShow = msg
        },
        go(index) {
            if(index==0) {
                this.$router.push({path:'/'})
            }else if(index==1) {
                if(this.streetId) {
                    window.open(`${this.commonIp}/htmls/pub/#/?streetId=${this.street_id}`,'_target')
                }else{
                    window.open(`${this.commonIp}/htmls/pub/#/`,'_target')
                }
            }else if(index==2){
                if(this.streetId) {
                    window.open(`${this.commonIp}/wap/linyouPin?currentId=db&place=0`,'_target')
                }else{
                    window.open(`${this.commonIp}/wap/linyouPin`,'_target')
                }
            }
        },


    }
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/index.less';
    header{
        height: 34px;
        line-height: 34px;
        font-size:@ft14;
        padding-right:120px;
        background:@bggray;
        .lnav{
            padding:0 20px;

        }
        .right{
            .fr();
            .ftBtn{
                width:62px;
                height: 100%;
                text-align: center;
                display: inline-block;
                background:#ea5d3c;
            }
            .avatar{
                width:20px;
                height: 20px;
                margin:0 0px 0 20px;
                border-radius:50%;
                vertical-align: middle;
                margin-top: -3px;
            }
        }
        a{
            color:#fff;

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/header2.vue